import { render, staticRenderFns } from "./CopyToAddressBlock.vue?vue&type=template&id=a396dcb8&scoped=true"
import script from "./CopyToAddressBlock.vue?vue&type=script&lang=js"
export * from "./CopyToAddressBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a396dcb8",
  null
  
)

export default component.exports